import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import {
  DistributionType,
  Partner,
  PartnershipType,
} from "../types/genericType";
import { convertToLocalYYYY_MM_DD } from "../utils/dateFormat";
import { Dayjs } from "dayjs";

export const getAllPartnerships = async (): Promise<PartnershipType[]> => {
  try {
    const response: AxiosResponse<PartnershipType[]> = await axiosInstance.get(
      apiEndPoints.partnerships
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getPartnershipById = async (
  id: number
): Promise<PartnershipType> => {
  try {
    const response: AxiosResponse<PartnershipType> = await axiosInstance.get(
      `${apiEndPoints.partnerships}/${id}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createPartnership = async (
  partnership: PartnershipType
): Promise<PartnershipType> => {
  try {
    const response: AxiosResponse<PartnershipType> = await axiosInstance.post(
      apiEndPoints.partnerships,
      partnership
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const editPartnership = async (
  partnership: PartnershipType
): Promise<PartnershipType> => {
  try {
    const response: AxiosResponse<PartnershipType> = await axiosInstance.put(
      apiEndPoints.partnerships,
      partnership
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getInvestorsByPartnershipId = async (
  id: number
): Promise<Partner[]> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `${apiEndPoints.partnerships}/${id}/investors`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createPartnerUnderPartnership = async (
  selectedPartnerId: number,
  account: number,
  percentage: number
): Promise<Partner> => {
  try {
    const response: AxiosResponse<Partner> = await axiosInstance.post(
      `${apiEndPoints.partnerships}/${selectedPartnerId}/investors`,
      {
        account,
        percentage,
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const editPartnerUnderPartnership = async (
  selectedPartnershipId: number,
  id: number,
  account: number,
  percentage: number
): Promise<Partner> => {
  try {
    const response: AxiosResponse<Partner> = await axiosInstance.put(
      `${apiEndPoints.partnerships}/${selectedPartnershipId}/investors`,
      {
        id,
        account,
        percentage,
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const removePartnerUnderPartnership = async (
  selectedPartnershipId: number,
  account: number
): Promise<Partner> => {
  try {
    const response: AxiosResponse<Partner> = await axiosInstance.delete(
      `${apiEndPoints.partnerships}/${selectedPartnershipId}/investors/${account}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getPartnerShipDistributions = async (
  id: number | undefined
): Promise<DistributionType[]> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `${apiEndPoints.partnerships}/${id}/distributions`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createDistribution = async (
  partnership: number | undefined,
  amount: number,
  date: Dayjs,
  description: string
): Promise<DistributionType> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post(
      `${apiEndPoints.distributions}`,
      {
        partnership,
        amount,
        date: convertToLocalYYYY_MM_DD(date),
        description,
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteDistribution = async (
  id: number
): Promise<DistributionType> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.delete(
      `${apiEndPoints.distributions}/${id}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};
